import { Modal } from 'react-bootstrap'

const StatementModal = ({ showModal, handleModalClose, handleSubmit, formData, handleChange, uomOptions, typeOptions, loading }) => {
    return (
        <>
            <Modal show={showModal} onHide={handleModalClose} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Add New Stock Item</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="grid grid-cols-1 md:grid-cols-2 space-y-1 gap-6">
                            <div>
                                <label className="block text-gray-700 mb-2" htmlFor="GroupName">
                                    Group Name*
                                </label>
                                <input
                                    type="text"
                                    id="GroupName"
                                    name="GroupName"
                                    value={formData.GroupName}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2" htmlFor="ItemName">
                                    Item Name*
                                </label>
                                <input
                                    type="text"
                                    id="ItemName"
                                    name="ItemName"
                                    value={formData.ItemName}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2" htmlFor="BrandName">
                                    Brand Name
                                </label>
                                <input
                                    type="text"
                                    id="BrandName"
                                    name="BrandName"
                                    value={formData.BrandName}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2" htmlFor="Type">
                                    Type*
                                </label>
                                <select
                                    id="Type"
                                    name="Type"
                                    value={formData.Type}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                >
                                    {typeOptions.map(option => (
                                        <option key={option} value={option}>{option}</option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2" htmlFor="UOM">
                                    Unit of Measurement*
                                </label>
                                <select
                                    id="UOM"
                                    name="UOM"
                                    value={formData.UOM}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                >
                                    <option value="">Select UOM</option>
                                    {uomOptions.map(option => (
                                        <option key={option} value={option}>{option}</option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2" htmlFor="CurrentLevel">
                                    Current Stock Level*
                                </label>
                                <input
                                    type="number"
                                    id="CurrentLevel"
                                    name="CurrentLevel"
                                    value={formData.CurrentLevel}
                                    onChange={handleChange}
                                    min="0"
                                    step="0.01"
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2" htmlFor="Rate">
                                    Rate (per unit)*
                                </label>
                                <input
                                    type="number"
                                    id="Rate"
                                    name="Rate"
                                    value={formData.Rate}
                                    onChange={handleChange}
                                    min="0"
                                    step="0.01"
                                    className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-gray-700 mb-2" htmlFor="Total">
                                    Total Value
                                </label>
                                <input
                                    type="text"
                                    id="Total"
                                    name="Total"
                                    value={formData.Total}
                                    readOnly
                                    className="w-full px-3 py-2 border rounded-md bg-gray-100"
                                />
                            </div>
                        </div>

                        <div className="space-y-1 mt-4">
                            <div className="text-lg  mb-2">
                                <span className="font-semibold">Unit Definitions</span> <span className="text-gray-700">(Optional)</span>
                            </div>

                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-gray-700 mb-2" htmlFor="itemUnit">
                                        Unit
                                    </label>
                                    <input
                                        type="number"
                                        step="any"
                                        name="itemUnit"
                                        value={formData.itemUnit}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>

                                <div>
                                    <label className="block text-gray-700 mb-2" htmlFor="UOM">
                                        Unit of Measurement*
                                    </label>
                                    <select
                                        id="itemUom"
                                        name="itemUom"
                                        value={formData.itemUom}
                                        onChange={handleChange}
                                        className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                    >
                                        <option value="">Select UOM</option>
                                        {uomOptions.map(option => (
                                            <option key={option} value={option}>{option}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div className="mt-6 flex justify-end space-x-4">
                            <button
                                type="button"
                                onClick={handleModalClose}
                                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
                            >
                                {loading ? 'Saving...' : 'Save Item'}
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default StatementModal